module.exports = __webpack_public_path__ + "img/blue.c1b3be5e.jpg";